import React from "react";
import {
  Control,
  Controller,
  FieldErrors,
  FieldValues,
  Path,
  RegisterOptions,
} from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import CustomErrorMessage from "@/components/forms/inputsWithRef/customErrorMessage";

interface GenericControllerWithInputProps<T extends FieldValues> {
  //   control: Control<FieldValues> | undefined;
  control: Control<T>;
  name: keyof T;
  rules?: RegisterOptions;
  renderInput: (props: any) => React.ReactElement | any;
  defaultValue?: keyof T | any;
  convertCurrency?: boolean;
}

const ForwardedGenericControllerWithInput = React.forwardRef(
  <T extends FieldValues>(
    {
      control,
      name,
      rules,
      renderInput,
      defaultValue,
    }: GenericControllerWithInputProps<T>,
    ref: React.ForwardedRef<HTMLInputElement>
  ) => {
    return (
      <Controller
        name={name as Path<T>}
        control={control}
        defaultValue={defaultValue}
        rules={rules as RegisterOptions<T, Path<T>>}
        render={({ field, formState: { errors } }) => (
          <>
            {renderInput({
              ...field,
              ref,
            })}
            <div
              style={{
                visibility: errors[name as string] ? "visible" : "hidden",
                minHeight: errors[name as string] ? "1.75rem" : "0",
              }}
            >
              <ErrorMessage
                errors={errors as FieldErrors} // ErrorMessage cannot infer field names from a generic form type
                name={name as string}
                render={({ message }) => (
                  <CustomErrorMessage error={"error"} errorMessage={message} />
                )}
              />
            </div>
          </>
        )}
      />
    );
  }
);
ForwardedGenericControllerWithInput.displayName = "DropdownSubjectSearchWithController";

const GenericControllerWithInput = ForwardedGenericControllerWithInput as <T extends FieldValues>(
  props: GenericControllerWithInputProps<T> & { ref?: React.Ref<HTMLInputElement> }
) => React.ReactElement; // forwardRef drops the type parameter, so the form's own field types would otherwise collapse to any

export default GenericControllerWithInput;
